export default "__VITE_ASSET__B$woHB2x__"